// src/main.tsx
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { AuthProvider } from "@/contexts/AuthContext";
import { WorkspaceOrgProvider } from "@/contexts/WorkspaceOrgContext";
import { AnchorEntitlementsProvider } from "@/contexts/AnchorEntitlementsContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { DevViewportFrame } from "@/components/dev/viewport/DevViewportFrame";
import { FreshAchievementsProvider } from "@/contexts/FreshAchievementsContext";
import { FireflyMotionSpeedProvider } from "@/contexts/FireflyMotionSpeedContext";
import { UserBootstrapRunner } from "@/hooks/useUserBootstrap";
import { UserUiPrefsHydrator } from "@/components/auth/UserUiPrefsHydrator";
import { installInteractionTracker } from "@/lib/lastUserInteraction";
import { requestPersistentStorage } from "@/lib/browser/durableKvStorage";

// Track the user's last interaction target so submitted bug reports can
// carry a concrete "what were they clicking on?" snapshot. Idempotent;
// safe to call here at the module level. See
// docs/planning/bug_report_active_context.md.
installInteractionTracker();
requestPersistentStorage();

// After a deploy, hashed chunks in a long-lived tab 404 and the SPA
// rewrite serves index.html — dynamic imports then fail with a MIME
// error. One automatic reload picks up the new asset map.
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <ThemeProvider>
        <WorkspaceOrgProvider>
          <AnchorEntitlementsProvider>
            <FreshAchievementsProvider>
              <FireflyMotionSpeedProvider>
              <DevViewportFrame>
                <UserBootstrapRunner />
                <UserUiPrefsHydrator />
                <App />
              </DevViewportFrame>
              </FireflyMotionSpeedProvider>
            </FreshAchievementsProvider>
          </AnchorEntitlementsProvider>
        </WorkspaceOrgProvider>
      </ThemeProvider>
    </AuthProvider>
  </StrictMode>
);
